const Axios         = require('axios');
const Qs = require('qs');
const AjaxPull      = require('./AjaxPull');

const GOAL_CLICK_TEASER = 1;
const GOAL_SCROLL       = 2;
const GOAL_LOAD_PAGE    = 3;
const GOAL_ERROR        = 4;

class Goals {

    constructor(v, config) {

        // this.ajaxPull = v.ajaxPull;

        this.uid = '';
        this.v = v;
        this.page = '';
        this.time = 0;

        setInterval(() => {
            this.time++;
        }, 1000);


        this.config      = {
            host     : config.host     || '',
            url      : config.url      || '',
            timeout  : config.timeout  || 3000,
        };
        this.ajaxPull = new AjaxPull(this.v.host,  {});
        console.log('Goals config', this.config);
    }

    listener(event) {


        let isAddScrollEvent = false;

        event.subscribeAll((data, type) => {

            switch (type) {

                case "EVENT_LOAD_PAGE":
                    this.page = data.query.sid9;
                    console.log('data.query.uid', data.query.uid);

                    let scroll = 0;
                    window.scrollHistory = [];

                    let scrollCell = () => {
                        let currentScroll = window.pageYOffset || document.documentElement.scrollTop;
                        currentScroll =  Math.floor(currentScroll / window.outerHeight) + 1;



                        if (currentScroll !== scroll && window.scrollHistory.indexOf(currentScroll) === -1) {
                            scroll = currentScroll;
                            window.scrollHistory.push(scroll);

                            this.reachGoal(GOAL_SCROLL, scroll, null, this.page);
                            //проверяем пропущенные скроллы
                            for (let i = 1; i < scroll; i++) {
                                if (window.scrollHistory.indexOf(i) === -1) {
                                    console.log("Пропущен скролл " + i);
                                    window.scrollHistory.push(i);
                                    this.reachGoal(GOAL_SCROLL, i, null, this.page);
                                }
                            }

                        }
                    };

                    if (!isAddScrollEvent) {
                        window.addEventListener('scroll', scrollCell);
                        isAddScrollEvent = true;
                    }


                    //цель: показ станицы
                    this.reachGoal(GOAL_LOAD_PAGE, null, null, this.page);
                    break;
                case "EVENT_TEASER_CLICK":

                    let index = data.teaser.index || 0;
                    //цель: клик по тизеру

                    this.reachGoal(GOAL_CLICK_TEASER, index, null, this.page);

                    // try {
                    //     ym(51842675,'reachGoal','click_to_teaser')
                    // } catch (e) {
                    //     console.warn('ym goal: ' + e.message)
                    // }


                    break;
            }
        });
    }

    setPage(page)
    {
        this.page = page;
    }

    reachGoalError(error) {
        console.error(error);
        this.reachGoal(GOAL_ERROR, 0, 0, error + ' theme: ' + this.v.theme + " ua: " + navigator.userAgent
            +  " url:" +  location.href)
    }

    reachGoal(targetId, value1, value2, value3) {
        if (value1 && !/^\d+$/.test(value1) ) {
            console.error('value1 должно быть целым числом');
            return;
        }

        if (value2 && !/^\d+$/.test(value2)) {
            console.error('value2 должно быть целым числом');
            return;
        }

        this._send(
            targetId,
            value1,
            value2,
            value3 || '');
    }

    // setUid(uid) {
    //     this.uid = uid;
    // }

    _send(targetId, value1, value2, value3) {
        return ; //Удалить чтобы запустить отправку

        let data = {
            target_id: targetId,
            value1: value1 || 0,
            value2: value2 || 0,
            value3: value3 || '',
            user_id: this.v.uid
        };

        // data.uri = this.config.host;
        // console.log('this.config.url', this.config.url);
        // console.log('this.config.host', this.config.host);
        let goalResponse =  this.ajaxPull.post({uri: this.config.url}, data, {
            baseURL: this.config.host,

            headers:{'Content-Type': 'application/x-www-form-urlencoded'},
            onBeforeRequest: (conf) => {
                if(!conf.data.user_id) conf.data.user_id = this.v.uid;
                conf.data = Qs.stringify(conf.data);
            },
        });
        goalResponse.onSuccess((response) => {
            console.log('goal response', response);
        });
    }
}

module.exports = Goals;